export default __webpack_public_path__ + "static/media/e-wallet.af46459d.svg";